<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                  [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/channel/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Channel Guideline</button>
                  </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="name">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <!-- <img
                        class="rounded-circle mr-1"
                        *ngIf="row.image"
                        [src]="imageUrl + row.image"
                        height="32"
                        width="32"
                      />
                      <img
                        class="rounded-circle mr-1"
                        *ngIf="!row.image"
                        src="assets/MeanderLIVE-icon.png"
                        height="32"
                        width="32"
                      /> -->

                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">{{ row?.name | shortName }}</div>
                    </div>
                    <div class="cell-line-height cursor-pointer">
                      <p class="font-medium-1 line-height-1 mb-0" [routerLink]="['/channel/view',row._id]">
                        {{ row.name }}
                      </p>
                      <!-- <span class="text-muted font-small-2">
                          Nuclear Power Engineer</span
                        > -->
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Category" prop="category">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.category?.displayname}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Technology" prop="technology">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.technology?.displayname}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Notes" prop="notes"></ngx-datatable-column>

              <ngx-datatable-column name="Actions"
                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/channel/edit']"
                    (click)="editChannel(row)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"></i>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

